import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Popover } from '@mui/material';
import { useId, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { VARIABLE_NAME_TO_COLUMN } from '../constantsArticleExcel';

const WarningsPopover = ({ warnings, excelRow, excelSheet }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();

  if (!warnings?.length) return null;

  return (
    <>
      <style>{`@keyframes warn-blink { 0%,100%{opacity:1} 50%{opacity:0.25} }`}</style>
      <span
        data-tooltip-id={`warn-tooltip-${id}`}
        data-tooltip-content="Haz clic para ver los avisos"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl((prev) => (prev ? null : e.currentTarget));
        }}
        style={{
          width: '3rem',
          minWidth: '3rem',
          maxWidth: '3rem',
          cursor: 'pointer',
          backgroundColor: '#e67f0057',
          padding: '0.2rem',
          borderRadius: '4px',
          // aspectRatio: '1',
          gap: '0.1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontStyle: 'italic',
          color: '#e67e00',
        }}
      >
        ({warnings.length})
        <InfoOutlinedIcon
          style={{
            color: '#e67e00',
            width: '1.2rem',
            height: '1.2rem',
            minWidth: '1.2rem',
            maxWidth: '1.2rem',
            aspectRatio: '1',
            animation: 'warn-blink 1.4s ease-in-out infinite',
          }}
        />
      </span>
      <Popover
        id={`warnings-popover-${id}`}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <div className="diff-popover-container" style={{ maxHeight: '320px', overflowY: 'auto', minWidth: '260px' }}>
          <p>Avisos ({warnings.length})</p>
          {excelSheet && excelRow && (
            <p style={{ fontSize: '0.75rem', color: '#888', margin: '0 0 0.4rem 0' }}>
              Pestaña: <strong>{excelSheet}</strong> · Fila: <strong>{excelRow}</strong>
            </p>
          )}
          <div>
            {warnings.map((w, idx) => (
              <p key={idx}>
                {w?.field && (
                  <strong style={{ marginRight: '0.3rem', color: '#e67e00' }}>
                    [{VARIABLE_NAME_TO_COLUMN[w.field] ?? w.field}]
                  </strong>
                )}
                {w?.message ?? w}
              </p>
            ))}
          </div>
        </div>
      </Popover>
      <Tooltip id={`warn-tooltip-${id}`} place="top" />
    </>
  );
};

export default WarningsPopover;
